export enum ResponseStatus {
    Ok = 200,
    NotFound = 404,
    Conflicted = 409
}
